import React from 'react';

const Body = () => (
    <>
        <h2>Environment Overview</h2>We understand the necessity of both local and global
        environmental stewardship, including the reduction of carbon emissions as part of JD Group’s
        obligation to help combat the challenges of climate change. During the period, a number of
        initiatives and reviews have been completed, resulting in a more detailed and comprehensive
        Group approach to sustainability and ESG (Environmental, Social and Governance) matters.
        <br />
        <br /> Independent verification of the Group’s continued progress towards reducing our
        environmental impact was provided by our December 2020 Carbon Disclosure Project (CDP)
        score. The Group progressed to an ‘A-’ grade for the most important category of ‘Carbon
        Management’, establishing JD Group within the ‘Leadership’ band for our approach to carbon
        management and reduction - the most integral components required to combat climate change.
        JD continues to out-perform both our category (Discretionary Retail) benchmark, and the
        wider European sector average score – this year by three grades.
        <br />
        <br />
        <img
            className="full"
            src="https://files.jdplc.com/images/about/December-2020-CDP-Score.jpg"
            alt=""
        />
        <br />
        <br />
        The CDP is recognised as a platform where investors, companies and cities take action on
        sustainability by measuring and understanding their management approach and impact achieved.
        Our CDP participation enables the Group to benchmark performance against industry peers,
        ensuring our strategy on carbon reduction is independently reviewed against comparable
        businesses.
        <br />
        <br /> Beyond our CDP score achievement, we have continued our support of, and compliance
        with the UK Government’s Carbon Reduction Commitment, including the new Streamlined Energy
        and Carbon Reporting (SECR) regime. In previous years, the JD Group fulfilled all of its
        Energy Savings Opportunity Scheme (ESOS) and Energy Efficiency Directive (EED) commitments,
        assisting the reduction of our environmental footprint and improving resource efficiency
        across the UK and Europe.
        <br />
        <br /> After the Group’s FTSE100 entry, we made further commitment to improving our
        sustainability and environmental performance by establishing our ESG Committee. The
        Committee determines our ESG strategy and related objectives, whilst monitoring adherence to
        our existing documented ESG standards and commitments.<h2>ESG – Key achievements:</h2>
        <ul className="list">
            <li>
                We advanced our reputation as a sustainable organisation through increasing the
                number of environmental performance benchmarks that we measure ourselves against.
                These include joining RE100 (the world’s most influential companies, committed to
                100% renewable power) to demonstrate our public commitment to renewable energy. In
                addition to our CDP-issued A- score for ‘Carbon Management’ we completed our second
                CDP Forests questionnaire, and achieved a fantastic ‘B’ score for our first ever CDP
                ‘Water Security’ submission, two grades above the average for the discretionary
                retail sector.
            </li>
            <li>
                As part of our measures to improve communication on our matters of current public
                and media interest (e.g. plastic usage, the Group re-launched its corporate website
                in late 2019. Our new site has served as a fantastic repository for our achievements
                and updates, garnering positive feedback from investors, brand partners and
                customers alike. All parties continue to benefit from greater transparency on our
                practices and we look forward to continuing to share our progress.
            </li>
            <li>
                Continuing our progress on moving JD European stores to 100% renewable energy usage,
                (consistent with our approach in the UK and Republic of Ireland). Our stores in
                Spain and Portugal are the latest to benefit from renewable energy supply. Through
                membership of the RE100, we have publicised our target of 100% renewable electricity
                use for our European operations by 2022, with the ambition for all existing global
                operations to be renewable by 2025.
            </li>
        </ul>
        More information about what we are doing to mitigate our impact on the environment can be
        found in our{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-and-accounts-2020.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>
        , the Energy &amp; Sustainability Sections of this website and our case studies below.
        <br />
        <br />
        Suppliers with ideas or innovations that would help to reduce our environmental impact are
        welcome to contact our Energy and Environment team via{' '}
        <a className="link" href="mailto:newsupplierenquiries@jdplc.com">
            newsupplierenquiries@jdplc.com
        </a>
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/environment.jpg',
    body: Body,
    lowerTitle: 'Our ESG Stories',
    lowerItems: [
        {
            content: 'Plastic Useage',
            url: 'https://files.jdplc.com/pdf/case-studies/Plastic-vs-Paper-The-Facts.pdf',
        },
        {
            content: 'Increasing Recycled Content (Online Packaging)',
            url: 'https://files.jdplc.com/pdf/case-studies/online-packaging.pdf',
        },
        {
            content: 'RE100 Commitment to Renewable Energy',
            url: 'https://files.jdplc.com/pdf/case-studies/JD-joins-the-RE100.pdf',
        },
        {
            content: "'Zero to Landfill': Kingsway Distribution Centre",
            url: 'https://files.jdplc.com/pdf/case-studies/zero-to-landfill.pdf',
        },
        {
            content: 'Science Based Targets',
            url: 'https://files.jdplc.com/pdf/case-studies/science-based-targets.pdf',
        },
        {
            content: 'Reducing Energy Usage',
            url: 'https://files.jdplc.com/pdf/case-studies/reducing-energy-usage.pdf',
        },
        {
            content: 'Office Recycling',
            url: 'https://files.jdplc.com/pdf/case-studies/Office-Recyling.pdf',
        },
        {
            content: 'Reducing Plastic',
            url: 'https://files.jdplc.com/pdf/case-studies/Reducing-Plastic-Consumables.pdf',
        },
        {
            content: 'Green Energy',
            url: 'https://files.jdplc.com/pdf/case-studies/Green-Energy.pdf',
        },
    ],
};
